import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Title } from '@angular/platform-browser';
import { Router } from '@angular/router';

import { AuthService } from '../../services/auth.service';

import { SweetAlertService } from './../../../shared/services/sweet-alert/sweet-alert.service';

@Component({
  selector: 'app-reset-password',
  templateUrl: './reset-password.component.html',
  styleUrls: ['./reset-password.component.scss']
})
export class ResetPasswordComponent implements OnInit {
  cardTitle: string = 'Redefinir Senha de Acesso';

  // Form definitions.
  form: FormGroup;
  @ViewChild('email') emailFocus: ElementRef;

  // Form submission control.
  submitted: boolean = false;

  // Control of loading of the service.
  segmentDimmed: boolean = true;

  constructor(
    private title: Title,
    private fb: FormBuilder,
    private authService: AuthService,
    private sweetAlertService: SweetAlertService,
    private router: Router
  ) { }

  ngOnInit() {
    this.title.setTitle(`SIVEL Check | ${ this.cardTitle }`);
    this.createForm();

    this.segmentDimmed = false;

    // Remove the message when animations was finished when click in the close button.
    $('.message').bind('animationend webkitAnimationEnd oAnimationEnd MSAnimationEnd', function(e) { $(this).remove(); });

    $('.message .close').on('click', function () {
      console.log('clicked');
      $(this).closest('.message').addClass('animated bounceOutUp');
    });
  }

  get email() {
    return this.form.get('email');
  }

  onSubmit() {
    // Disable submit to avoid multiple requests.
    this.submitted = true;
    this.segmentDimmed = true;

    return this.authService.resetPassord(this.email.value)
      .then(user => {
        if (this.form.valid) {
          this.submitted = false;
          this.segmentDimmed = false;

          this.sweetAlertService.success({ message: 'Redefinição de senha de acesso solicitada com sucesso. Verifique o seu e-mail.' });

          // Go to '/' or to last visited url before system logout.
          this.router.navigate(['/sign-in']);
        }
      })
      .catch(error => {
        this.submitted = false;
        this.segmentDimmed = false;

        console.log(error);

        this.sweetAlertService.error({ message: this.authService.errorMessage(error.code) }).then(() => {
          this.emailFocus.nativeElement.focus();
          this.emailFocus.nativeElement.select();
        });
      });
  }

  resetForm(fieldFocus?: HTMLElement) {
    this.form.reset();

    if (fieldFocus) {
      fieldFocus.focus();
    }
  }

  private createForm() {
    this.form = this.fb.group({
      email: ['', Validators.compose([Validators.required, Validators.email])]
    });
  }
}
